import { Controller } from "@hotwired/stimulus"

// Filters the target select based on the selected source.
// When a source restricts to exactly one target, the select is hidden and
// replaced with a static label; the hidden-but-still-submitted select carries
// the forced value.
export default class extends Controller {
  static targets = ["sourceSelect", "targetSelect", "staticDisplay", "staticLabel"]
  static values  = { restrictions: Object }

  connect() {
    // Snapshot all original options so we can restore them when switching sources
    this.allOptions = Array.from(this.targetSelectTarget.options).map(opt => ({
      value: opt.value,
      text:  opt.text
    }))
    this.filterTargets()
  }

  filterTargets() {
    const source  = this.sourceSelectTarget.value
    const allowed = this.restrictionsValue[source]

    if (allowed && allowed.length === 1) {
      this.#forceTarget(allowed[0])
    } else if (allowed && allowed.length > 1) {
      this.#filterToAllowed(allowed)
    } else {
      this.#restoreAll()
    }
  }

  // ── private ───────────────────────────────────────────────────────────────

  #forceTarget(targetValue) {
    const option = this.allOptions.find(o => o.value === targetValue)
    if (!option) return

    // Keep the select value correct so it submits properly
    this.targetSelectTarget.value = targetValue

    // Hide the real select wrapper, show the static read-only display
    this.targetSelectTarget.closest(".select-field-wrapper").classList.add("d-none")
    this.staticDisplayTarget.classList.remove("d-none")
    this.staticLabelTarget.textContent = option.text
  }

  #filterToAllowed(allowed) {
    this.#restoreAll()

    // Remove options not in the allowed list
    Array.from(this.targetSelectTarget.options).forEach(opt => {
      if (opt.value && !allowed.includes(opt.value)) {
        opt.remove()
      }
    })

    this.targetSelectTarget.closest(".select-field-wrapper").classList.remove("d-none")
    this.staticDisplayTarget.classList.add("d-none")
  }

  #restoreAll() {
    const select = this.targetSelectTarget
    select.innerHTML = ""
    this.allOptions.forEach(({ value, text }) => {
      const opt = document.createElement("option")
      opt.value = value
      opt.text  = text
      select.appendChild(opt)
    })

    select.closest(".select-field-wrapper").classList.remove("d-none")
    this.staticDisplayTarget.classList.add("d-none")
  }
}
